export enum RoleAccessMethodEnum {
	POST="POST",
	GET="GET",
	PUT="PUT",
	DELETE="DELETE",
	ALL="ALL"
}